import React from "react";
import { PublicLayout, Eyebrow, SectionCTA, IMG } from "@/components/public/PublicKit";
import { Search, UserPlus, Layers, Share2, BarChart3 } from "lucide-react";

const STEPS = [
  { icon: Search, title: "Acquire providers", desc: "Find and capture practices and physicians, then build them into your pipeline as leads and opportunities." },
  { icon: UserPlus, title: "Onboard clients", desc: "Convert won deals into clients, track documentation and DTCM form completion, and mark readiness to start." },
  { icon: Layers, title: "Activate services", desc: "Add 340B, RPM, infusion or your own services to a client — each with its own status, partner and owner." },
  { icon: Share2, title: "Track referrals", desc: "Log referrals and move them from submitted to completed, with owners, follow-ups and a full history." },
  { icon: BarChart3, title: "Report & follow up", desc: "See converted clients, DTCM progress, active services and referrals by status — all from real records." },
];

export default function HowItWorks() {
  return (
    <PublicLayout>
      <section className="border-b border-slate-100 bg-slate-50">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-20">
          <Eyebrow>How It Works</Eyebrow>
          <h1 className="max-w-3xl font-display text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">From provider acquisition to active service in five steps</h1>
          <p className="mt-4 max-w-2xl text-lg text-slate-500">HudlUp keeps the whole journey connected, so handoffs between sales, onboarding and operations never fall through the cracks.</p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-[1.1fr_1fr]">
          <ol className="space-y-5">
            {STEPS.map((s, i) => (
              <li key={s.title} data-testid={`hiw-step-${i + 1}`} className="flex gap-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <span className="relative inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                  <s.icon className="h-5 w-5" />
                  <span className="absolute -right-1.5 -top-1.5 inline-flex h-5 w-5 items-center justify-center rounded-full bg-primary text-[11px] font-bold text-white">{i + 1}</span>
                </span>
                <div><p className="font-display text-lg font-bold text-slate-900">{s.title}</p><p className="mt-0.5 text-sm leading-relaxed text-slate-500">{s.desc}</p></div>
              </li>
            ))}
          </ol>
          <div className="lg:sticky lg:top-24">
            <img src={IMG.data} alt="Team reviewing client data" loading="lazy" className="aspect-[3/4] w-full rounded-3xl object-cover shadow-xl ring-1 ring-slate-200" />
          </div>
        </div>
      </section>

      <SectionCTA />
    </PublicLayout>
  );
}
